export default __webpack_public_path__ + "static/media/stacked-cards-theme1.6fee8555.svg";